import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_INVENTORY_NODE,
    GET_ALL_INVENTORY_NODES,
    GET_INVENTORY_NODE_REQUEST,
    CREATE_INVENTORY_NODE,
    UPDATE_INVENTORY_NODE,
    DELETE_INVENTORY_NODE,
    CLEAR_INVENTORY_NODE,
    INVENTORY_NODE_ERROR,
    INVENTORY_NODE_LOADING
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all inventory nodes
export const getInventoryNodes = (params = '') => async dispatch => {
    try {
        dispatch({ type: INVENTORY_NODE_LOADING });
        
        const res = await axios.get(`${API_URL}/inventory/nodes${params}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_INVENTORY_NODES,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: INVENTORY_NODE_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get inventory nodes by sector
export const getInventoryNodesBySector = (sectorId) => async dispatch => {
    try {
        dispatch({ type: INVENTORY_NODE_LOADING });
        
        const res = await axios.get(`${API_URL}/inventory/nodes?sector=${sectorId}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_INVENTORY_NODES,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: INVENTORY_NODE_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get inventory nodes by serviceable area
export const getInventoryNodesByServiceableArea = (serviceableAreaId) => async dispatch => {
    try {
        dispatch({ type: INVENTORY_NODE_LOADING });
        
        const res = await axios.get(`${API_URL}/inventory/nodes?serviceableArea=${serviceableAreaId}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_INVENTORY_NODES,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: INVENTORY_NODE_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get inventory node by ID
export const getInventoryNode = (id) => async dispatch => {
    try {
        dispatch({ type: GET_INVENTORY_NODE_REQUEST });
        
        const res = await axios.get(`${API_URL}/inventory/nodes/${id}`);
        if(res.data.success){
            dispatch({
                type: GET_INVENTORY_NODE,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        };
    } catch (err) {
        dispatch({
            type: INVENTORY_NODE_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Create inventory node
export const createInventoryNode = (formData) => async dispatch => {
    try {
        dispatch({ type: INVENTORY_NODE_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.post(`${API_URL}/inventory/nodes`, formData, config);
        if(res.data.success){
            dispatch({
                type: CREATE_INVENTORY_NODE,
                payload: res.data.data
            });
            dispatch(setAlert('Inventory node created successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to create inventory node', 'danger'));
        }
        
        dispatch({
            type: INVENTORY_NODE_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Update inventory node
export const updateInventoryNode = (id, formData) => async dispatch => {
    try {
        dispatch({ type: INVENTORY_NODE_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.put(`${API_URL}/inventory/nodes/${id}`, formData, config);
        
        dispatch({
            type: UPDATE_INVENTORY_NODE,
            payload: res.data.data
        });
        if(res.data.success){
            dispatch(setAlert('Inventory node updated successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
        
        return res.data;
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to update inventory node', 'danger'));
        }
        
        dispatch({
            type: INVENTORY_NODE_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Delete inventory node
export const deleteInventoryNode = (id) => async dispatch => {
    try {
        dispatch({ type: INVENTORY_NODE_LOADING });
        
        const res = await axios.delete(`${API_URL}/inventory/nodes/${id}`);
        
        dispatch({
            type: DELETE_INVENTORY_NODE,
            payload: id
        });
        if(res.data.success){
            dispatch(setAlert('Inventory node deleted successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch({
            type: INVENTORY_NODE_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        dispatch(setAlert('Failed to delete inventory node', 'danger'));
    }
};

// Clear inventory node
export const clearInventoryNode = () => dispatch => {
    dispatch({ type: CLEAR_INVENTORY_NODE });
};
